import './tooltip.css';
export var tooltipAnimationWrapperCSS = '_hplwyr2-3-12-1';
export var tooltipElementCSS = '_hplwyr1-3-12-1';
export var tooltipOffsetVar = 'var(--_hplwyr0-3-12-1)';